import React from 'react'

class NavStatusUebersicht extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M4.5 5h11v1h-11V5zM7 18.5V20H0V0h20v9h-1.5V1.5h-17v17H7zm7.306-1.321l2.279 1.107-.35-2.51 1.758-1.824-2.494-.443-1.193-2.235-1.192 2.235-2.494.443 1.757 1.825-.349 2.509 2.278-1.107zm0 1.112l-3.526 1.713.54-3.883-2.72-2.825 3.86-.687 1.846-3.459 1.846 3.46 3.86.686-2.719 2.825.54 3.883-3.527-1.713z"
        />
      </svg>
    )
  }
}

export default NavStatusUebersicht
